import { Company } from "../client/typesDefinition";
import { Entity, PaginatedResponse, PaginatedResult } from "../typesDefinition";
import { Offered, Project } from "@/helpers/project/typesDefinition";
import { Order } from "@/helpers/order/typesDefinition";
import { User } from "@/helpers/user/typesDefinition";

export interface OrderTimesheetReport {
  ordersTotal: number;
  timesheetInvoiced: number;
  performedTimesheetsTotal: number;
  totalExpensesNet: number;
  totalUninvoicedOfferedNet: number;
  hasUnvalidatedOfferedAmount: boolean;
  invoicedTotal: number;
  toInvoice: number;
  toInvoiceGross: number;
  clientId: string;
  clientName: string;
  projectId: string;
  projectName: string;
  draftInvoice: Invoice;
}

export interface ClientToInvoiceReport {
  id: string;
  clientId: string;
  clientName: string;
  ordersTotal: number;
  performedTimesheetsTotal: number;
  totalExpensesNet: number;
  totalUninvoicedOfferedNet: number;
  hasUnvalidatedOfferedAmount: boolean;
  invoicedTotal: number;
  toInvoice: number;
  toInvoiceGross: number;
  commentsCount: number;
  projects: OrderTimesheetReport[];
}

export type InvoiceStatus =
  | "draft"
  | "sent"
  | "paid"
  | "partially_paid"
  | "canceled"
  | "reminder_1"
  | "reminder_2"
  | "reminder_3";

export enum InvoiceStatusAsEnum {
  DRAFT = "draft",
  SENT = "sent",
  PARTIALLY_PAID = "partially_paid",
  PAID = "paid",
  CANCELED = "canceled",
  REMINDER_1 = "reminder_1",
  REMINDER_2 = "reminder_2",
  REMINDER_3 = "reminder_3",
}

export type InvoiceType = "order" | "timesheet" | "other";

export interface Invoice extends Entity {
  id: string;
  type: InvoiceType;
  linkedResource?: Order;
  invoiceStatus: InvoiceStatus;
  date: string;
  dueDate?: string;
  total: number;
  balance: number;
  netTotal: number;
  invoiceNumber?: string;
  company: Company;
  project?: Project;
  projectId?: string;
  communication?: string;
  comment?: string;
  promisedDate?: Date;
  assignedTo: User;
  collectionStatus: InvoiceCollectionStatus;
  offered: [Offered];
}

export interface InvoicePaginatedResponse extends PaginatedResponse<Invoice> {
  invoices: PaginatedResult<Invoice>;
}
export interface InvoicesMenuItem {
  menuDate: string;
  menuTotal: number;
  menuBalance: number;
  menuOrdered: number;
}

export interface IndependentInvoicesResponse
  extends PaginatedResponse<Invoice> {
  independentInvoices: PaginatedResult<Invoice>;
}

export interface CompanyInvoices {
  id: string;
  name: string;
  invoices: Invoice[];
}

export interface AmountWithVAT {
  net: number;
  gross: number;
}

export interface CompanyFinancialData {
  id: string;
  name: string;
  totalInvoiced: AmountWithVAT;
  totalPaid: number;
  totalToPay: number;
}

export enum InvoicingRole {
  ADMIN = "admin",
  FINANCIAL = "financial",
}

export enum InvoiceCollectionStatus {
  DOUBTFUL = "doubtful_debt",
  ABANDONED = "abandoned_debt",
  CREDIT_NOTE_TO_ISSUE = "credit_note_to_issue",
  EXPECTED_PAYMENT = "expected_payment",
  FAR_FUTURE = "far_future",
}

export enum LateFilterOptions {
  DUE_AND_PROMISED_DATE_LATE = "due_and_promised_date_late",
  DELAYED = "delayed",
}
